// Copyright (c) 2016 Deere & Company

import './other-credits-panel.scss';
import React, {PropTypes} from 'react';
import {
    getVsrMessageForClaimItem,
    hasVsrErrorForClaimItem
} from '../../services/claim-shared-helper';
import ClaimVsrMessage from '@deere/cps-it.warranty-model-factory/lib/claim-vsr-message';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import NonEditableOtherCreditPanel from './non-editable-other-credits-panel';
import OtherCreditsPanelRowBody from './other-credits-panel-row-body';
import OtherCreditsPanelRowHeader from './other-credits-panel-row-header';
import {buildNumber} from '../../../../shared/services/build-number';

function handleDelete(index) {

    this.onDelete(index);

}

function handleDescriptionChange(index, description, descriptionCollection) {

    this.onDescriptionChange(index, description, descriptionCollection);

}

function handleAmountChange(index, amount) {

    const updatedAmount = amount ?
        amount :
        null;

    this.onAmountChange(index, updatedAmount);

}

function handleDistanceChange(index, distance) {

    const updatedDistance = distance ?
        distance :
        null;

    this.onDistanceChange(index, updatedDistance);

}

function handleCommentsChange(index, comments) {

    this.onCommentsChange(index, comments);

}

const getEditable = props =>
    props.otherCredits.map((credit, index) =>
        <OtherCreditsPanelRowBody
            credit={credit}
            highlightClass={hasVsrErrorForClaimItem(props.errors, 'OTHERCREDITS', credit.lineNumber)}
            isEditable={props.isEditable}
            key={index}
            onAmountChange={handleAmountChange.bind(props, index)}
            onCommentsChange={handleCommentsChange.bind(props, index)}
            onDelete={handleDelete.bind(props, index)}
            onDescriptionChange={handleDescriptionChange.bind(props, index)}
            onDistanceChange={handleDistanceChange.bind(props, index)}
            otherCreditDescriptions={props.otherCreditDescriptions}
            vsrMessage={getVsrMessageForClaimItem(props.errors, 'OTHERCREDITS', credit.lineNumber)}
        />
    );

const getNonEditable = props =>
    props.otherCredits.map((credit, index) =>
        <NonEditableOtherCreditPanel
            credit={credit}
            distanceColumnLabel={props.distanceColumnLabel}
            key={index}
        />
    );

const OtherCreditsPanel = props =>
    <section className='other-credits-panel'>
        <h3 className='other-credits-panel-title'>
            <FormattedMessage
                id='OTHER_CREDITS_WITH_COUNT'
                values={{
                    count: buildNumber(props.otherCredits.length)
                }}
            />
        </h3>
        {props.isEditable && <OtherCreditsPanelRowHeader distanceColumnLabel={props.distanceColumnLabel}/>}
        <section className='other-credit-list'>
            {props.isEditable ?
                getEditable(props) :
                getNonEditable(props)
            }
        </section>
        {props.isEditable &&
            <button
                className='add-other-credits-icon-button'
                onClick={props.onCreate}
            />
        }
    </section>;

OtherCreditsPanel.displayName = 'OtherCreditsPanel';
OtherCreditsPanel.propTypes = {
    distanceColumnLabel: PropTypes.string.isRequired,
    errors: PropTypes.arrayOf(PropTypes.instanceOf(ClaimVsrMessage)),
    isEditable: PropTypes.bool.isRequired,
    onAmountChange: PropTypes.func.isRequired,
    onCommentsChange: PropTypes.func.isRequired,
    onCreate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onDescriptionChange: PropTypes.func.isRequired,
    onDistanceChange: PropTypes.func.isRequired,
    otherCreditDescriptions: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    otherCredits: PropTypes.array.isRequired
};

OtherCreditsPanel.defaultProps = {
    distanceColumnLabel: 'DISTANCE'
};

export default OtherCreditsPanel;



// WEBPACK FOOTER //
// ./src/claim/shared/components/other-credits-panel/index.js